<script setup>

import FieldsTableRow from '../FieldsTableRow.vue'
import {computed, ref, watch} from "vue";
import { store } from "@/store";

const props = defineProps({
  saving: Object,
  calculating: Boolean,
})

const emit = defineEmits(['calcDone'])
const inputSavingValue = ref(0)
const propCalculating = computed(() => {
  return props.calculating;
})
watch(inputSavingValue, () => {
  checkValid()
}) // Check input validity when value changes
watch(propCalculating, (newVal) => {
  if (newVal) calculateSaving()
}) // Do the calculation
const checkValid = () => {
  props.saving.valid = (parseInt(inputSavingValue.value) > 0);
}
const calculateSaving = () => {
  setTimeout(() => {
    props.saving.valueAnnual = parseInt(inputSavingValue.value);
    props.saving.valueWeekly = parseInt(inputSavingValue.value) / 52;
    emit('calcDone');
  }, 20);
}
</script>

<template>
  <FieldsTableRow
      v-bind:label="`Please enter the estimated pension at ${store.formData.user.sra} from any DB retirement savings you have`">
    <input v-model="inputSavingValue" type="number" min="0" step="1" :disabled="props.calculating">
  </FieldsTableRow>
  <FieldsTableRow v-bind:justText="true">
    Ideally this should be the estimated annual pension at age {{ store.formData.user.sra }}. If this is not available
    you can add the estimated pension at a different date, however you should consider when reviewing your results
    whether this part of your retirement income will be greater or less than what you have input. You should be able to
    request an estimate from the relevant scheme administrator.
  </FieldsTableRow>
  <!-- <FieldsTableRow v-bind:justText="true">
    If you are planning to use some of your retirement savings to fund a tax-free cash sum, you will need to input the figures above after the desired level of cash has been taken into account.
  </FieldsTableRow> -->
</template>
